export enum IconSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export interface IIconProps extends React.SVGProps<SVGSVGElement> {
  size?: IconSize;
  className?: string;
}
